import Stack from "@mui/material/Stack"
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import {useApiCallback} from "./common/util/Api";
import {useEffect, useState} from "react";

function A({href, children}) {

    return <Box component="a" m={2} sx={{color: '#fff', textDecoration: 'none', textAlign: 'center'}} href={href}>
        <Stack direction="column">{children}</Stack>
    </Box>
}

function Img({src}) {
    return <Box component="img" src={src}
                sx={{width: '120px', border: '1px solid white', borderRadius: 2, overflow: 'hidden'}}/>
}


export default function Home() {

    const [data, setData] = useState([]);
    const getSites = useApiCallback('GET', '/api/sites', {onDone: setData});

    useEffect(() => {
        getSites();
    }, [getSites]);

    return (
        <Container>
            <Box component="h2">Please select a link.</Box>

            <Box sx={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 4}}>

                {data.map(site => {
                    if (typeof(site) === 'string') {
                        return <Box component="h3" sx={{width:'100%'}}>{site}</Box>
                    }
                    return (<A href={site.url}>
                        <Img src={site.url+'/dea_512.png'}/>{site.name}
                    </A>)
                })}
            </Box>
        </Container>
    )
}
